const AUTH_FLOW_PATHS = ['/login', '/mfa', '/mfa/choose', '/sso'];

const pathAfterLogin = {
  needsPasswordChange: (ProfileService, getToken) => {
    const token = ProfileService.parseJWT(getToken());
    if (!token) return false;
    const localSuccessChangePassword = localStorage.getItem('SUCCESS_CHANGE_PASSWORD');
    return !!(
      token.changePassword &&
      (!localSuccessChangePassword || parseInt(localSuccessChangePassword, 10) === 0)
    );
  },
  getNormalizedPath: (path, options = {}) => {
    const { leadingSlash = true, fallback = '' } = options;
    const trimmed = (path || '').trim();

    if (!trimmed || trimmed === '?' || trimmed === '/') {
      return fallback;
    }

    if (/^https?:\/\//i.test(trimmed) || /^\/\/[^/]/.test(trimmed) || trimmed.includes('\\')) {
      return fallback;
    }

    const withoutLeadingSlashes = trimmed.replace(/^\/+/, '');
    if (!withoutLeadingSlashes) {
      return fallback;
    }

    return leadingSlash ? `/${withoutLeadingSlashes}` : withoutLeadingSlashes;
  },
  isAuthFlowPath: (path) => {
    const normalized = pathAfterLogin.getNormalizedPath(path, {
      leadingSlash: true,
      fallback: '',
    });
    if (!normalized) {
      return false;
    }
    const pathname = normalized.split('?')[0];
    if (AUTH_FLOW_PATHS.includes(pathname)) {
      return true;
    }
    return pathname.startsWith('/sso/');
  },
  setPath: (pathToSave, isAuthenticated, searchToSave = '') => {
    if (isAuthenticated) {
      return;
    }
    const normalizedPath = pathAfterLogin.getNormalizedPath(pathToSave, {
      leadingSlash: true,
      fallback: '',
    });
    if (!normalizedPath) {
      return;
    }
    const fullPath = searchToSave ? `${normalizedPath}${searchToSave}` : normalizedPath;
    if (pathAfterLogin.isAuthFlowPath(fullPath)) {
      return;
    }
    localStorage.setItem('pathAfterLogin', fullPath);
  },
  getPath: (ProfileService, getToken) => {
    if (pathAfterLogin.needsPasswordChange(ProfileService, getToken)) {
      return '/reset';
    }
    const path = localStorage.getItem('pathAfterLogin');
    if (!path || pathAfterLogin.isAuthFlowPath(path)) {
      return '/home';
    }
    return path;
  },
  getPathWithoutToken: () => {
    return localStorage.getItem('pathAfterLogin') || '';
  },
  getPathForSsoRedirect: () => {
    const path = pathAfterLogin.getNormalizedPath(pathAfterLogin.getPathWithoutToken(), {
      leadingSlash: false,
      fallback: '',
    });
    if (!path || pathAfterLogin.isAuthFlowPath(path)) {
      return '';
    }
    return path;
  },
  resolvePostSsoPath: (redirectToFromQuery) => {
    const fromQuery = pathAfterLogin.getNormalizedPath(redirectToFromQuery, {
      leadingSlash: true,
      fallback: '',
    });
    if (fromQuery && !pathAfterLogin.isAuthFlowPath(fromQuery)) {
      return fromQuery;
    }

    const fromStorage = pathAfterLogin.getNormalizedPath(pathAfterLogin.getPathWithoutToken(), {
      leadingSlash: true,
      fallback: '',
    });
    if (fromStorage && !pathAfterLogin.isAuthFlowPath(fromStorage)) {
      return fromStorage;
    }

    return '/home';
  },
  removePath: () => {
    localStorage.removeItem('pathAfterLogin');
  }
}

export default pathAfterLogin;
